import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const SmallLeftIcon = createSvgIcon(
  <>
    <title>small left</title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="square"
      strokeLinejoin="miter"
      strokeWidth="1"
      transform="translate(0.5 0.5)"
    >
      <polyline
        fill="none"
        points="19,22 13,16 19,10 "
        stroke="#222222"
        strokeMiterlimit="10"
        transform="translate(0, 0)"
      />
    </g>
  </>
)
